import { render, staticRenderFns } from "./SuppliersForm.vue?vue&type=template&id=0e054072&"
import script from "./SuppliersForm.vue?vue&type=script&lang=js&"
export * from "./SuppliersForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports